import { ISetting } from '@/types'
import { getAppHost } from '@/utils/getAppHost'

// Dynamic host detection - no hardcoded URLs needed
const HOST = getAppHost()

export const baseSettings: Partial<ISetting> = {
  app: {
    code: 'fanatiz',
    title: 'Fanatiz',
    description: 'Watch live soccer games and sports like Copa Libertadores, Liga Profesional de Argentina, Brasileirāo, Ligue 1 and more. Watch on Web, Apple TV, Roku, Fire TV, Android, iOS.',
  },
  fonts: {
    base: 'gilroy',
    display: 'zuume',
  },
  images: {
    ogImage: 'https://www.fanatiz.com/fanatiz/web/other/og-image-Fanatiz.png',
    qrCode: '/assets/images/fanatiz/qr.svg',
    lottie: '/assets/lotties/clients/fanatiz/main/loading.json',
    favicons: {
      icon: '/assets/images/fanatiz/favicons/favicon.ico',
      svg: '/assets/images/fanatiz/favicons/icon.svg',
      apple: '/assets/images/fanatiz/favicons/apple-touch-icon.png',
    },
  },
  gtm: {
    id: 'GTM-WLL35HV3',
    gateway: {
      enabled: true,
    },
  },
  cmp: {
    id: '3f9df9f53293b',
  },
  youbora: {
    accountCode: 'fanatiz',
    active: false,
  },
  intercom: {
    enabled: true,
  },
  wsc: {
    key: '702ed17a0eff4ccda76e7772c840bfe4'
  },
  optimizely: {
    sdkKey: 'TGhTYhnEYoEbUxpW9qp5h',
    isActive: false,
  },
}

export const envOverrides: Record<string, Partial<ISetting>> = {
  development: {
    app: {
      title: 'Fanatiz - Development',
      description: 'Fanatiz - Development',
    },
    api: {
      host: HOST,
      cinematicsTag: 'fanatizDev',
    },
    optimizely: {
      sdkKey: 'Vxw39YYYPdX1wkZauXMQ7',
      isActive: true,
    },
    features: {
      teamBranding: true,
    },
  },
  staging: {
    api: {
      host: HOST,
      cinematicsTag: 'fanatizStaging',
    },
    gtm: {
      id: 'GTM-WVCF63J7',
    },
    youbora: {
      accountCode: 'fanatiz',
      active: true,
    },
    // Explicit pin: fanatiz never ships team branding. Counter-pins the
    // dev-block default so a missing NEXT_PUBLIC_APP_ENV can't enable it.
    features: {
      teamBranding: false,
    },
  },
  production: {
    api: {
      host: HOST,
      cinematicsTag: 'fanatizProd',
    },
    gtm: {
      id: 'GTM-WVCF63J7',
    },
    features: {
      teamBranding: false,
    },
    cmp: {
      id: 'c97fceb682ff8',
    },
    youbora: {
      accountCode: 'fanatiz',
      active: true,
    },
  },
}